"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preact = require("preact");

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var StateTracker = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(StateTracker, _Component);

  var _super = _createSuper(StateTracker);

  function StateTracker(props) {
    var _this;

    (0, _classCallCheck2.default)(this, StateTracker);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "initialState", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "currentState", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "alertOnExit", true);
    _this.currentState = null;
    _this.onBeforeUnload = _this.onBeforeUnload.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(StateTracker, [{
    key: "restoreToInitial",
    value: function restoreToInitial() {
      this.currentState = this.initialState;
      this.setState(this.initialState);
      this.setState({
        hasChanged: false
      });
    }
  }, {
    key: "hasChanged",
    value: function hasChanged() {
      return !(0, _isEqual.default)(this.currentState, this.initialState);
    }
  }, {
    key: "trackStateChange",
    value: function trackStateChange(newState) {
      this.currentState = newState;
      this.setState(newState);
      this.setState({
        hasChanged: this.hasChanged()
      });
    }
  }, {
    key: "onBeforeUnload",
    value: function onBeforeUnload(e) {
      if (!this.hasChanged()) return;
      e.preventDefault();
      e.returnValue = '';
    }
  }, {
    key: "registerAlert",
    value: function registerAlert() {
      if (this.alertOnExit) {
        window.addEventListener('beforeunload', this.onBeforeUnload);
      }
    }
  }, {
    key: "unRegisterAlert",
    value: function unRegisterAlert() {
      if (this.alertOnExit) {
        window.removeEventListener('beforeunload', this.onBeforeUnload);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.registerAlert();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unRegisterAlert();
    }
  }, {
    key: "setInitialState",
    value: function setInitialState(state) {
      this.initialState = state;
      this.currentState = state;
      this.setState({
        hasChanged: false
      });
    }
  }]);
  return StateTracker;
}(_preact.Component);

exports.default = StateTracker;